export default __webpack_public_path__ + "static/media/sp-slides-large.2d8a886a.jpg";